import Template from 'backbone/platform/templates/assets/media_library_assets_layout.js.hamlc'
import MediaLibraryAssetsCollectionView from 'backbone/platform/views/assets/media_library_assets_collection_view.js'
import AssetsFiltersView from 'backbone/platform/views/assets/assets_filters_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class MediaLibraryAssetsLayoutView extends Backbone.View
  events:
    "click .js-clear-search"          : "trackClearSearch"
    "keyup .asset-search"             : "trackSearch"
    "click .headers .header-text"     : "sortByColumn"

  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("toggleAssetsView", @toggleAssetsView)
    @dispatcher.bind("collectionLoaded", @renderFilters)
    @dispatcher.bind("redactorModalClosed", @remove)
    @dispatcher.bind("searchAssets", @search)
    @options = options

  render: ->
    @_cleanupSubviews()
    @$el.html(Template())

    @subviews = []
    if @options.mediaLibraryAccess
      @collectionView = new MediaLibraryAssetsCollectionView
        el: @$(".js-assets-container")
        brandProfileId: @options.brandProfileId
        clickCallback: @options.clickCallback
        collection: @options.collection
        viewStyle: "tile-view"
      @subviews.push(@collectionView)

    @$(".assets-frame").scroll =>
      @onScroll()

    if @scrollPosition?
      @$(".assets-frame").scrollTop(@scrollPosition)

    this

  renderFilters: (collection) =>
    @subviews = [] unless @subviews?
    @filtersView = new AssetsFiltersView
      collection: collection
      el: @$('.asset-filters')
    @filtersView.render()
    @subviews.push(@filtersView)

  search: (e) =>
    if e.target.id == "query"
      e.preventDefault()
      @filtersView.changeFilters(e)

  toggleAssetsView: (viewStyle) =>
    collection = @collectionView.collection
    @collectionView.remove()

    collectionViewOptions =
      collection: collection
      el: @$(".js-assets-container")
      brandProfileId: @options.brandProfileId
      clickCallback: @options.clickCallback
      viewStyle: viewStyle

    @collectionView =
      new MediaLibraryAssetsCollectionView(
        collectionViewOptions
      )

    @subviews.push(@collectionView)
    @_logMixpanelEvent("ml-format-toggle", {view_style: viewStyle})

  onScroll: ->
    @scrollPosition = @$(".assets-frame").scrollTop()

  pickedAssets: ->
    @collectionView?.pickedAssets()

  deselectAll: ->
    @collectionView.collection.deselectAll()

  remove: =>
    @_cleanupSubviews()
    $(document).off("keydown", @search)
    @dispatcher.unbind("toggleAssetsView", @toggleAssetsView)
    @dispatcher.unbind("collectionLoaded", @renderFilters)
    @dispatcher.unbind("redactorModalClosed", @remove)
    @dispatcher.unbind("searchAssets", @search)
    super

  trackSearch: (e) ->
    @_logMixpanelEvent("ml-search", {query: @$("#query").val()}) if e.which == 13

  trackClearSearch: ->
    @_logMixpanelEvent("ml-search-cleared", {})

  sortByColumn: (e) ->
    sortBy = $(e.currentTarget).parent("th").data("sortBy")
    @_logMixpanelEvent("ml-list-view-sorted", {sort_by: sortBy})


  _cleanupSubviews: ->
    if @subviews
      _.each @subviews, (subview) ->
        subview.remove()
      delete @subviews

  _logMixpanelEvent: (eventName, eventOptions) ->
    baseOptions =
      distinct_id: contently.ui.current_user.id
      mp_name_tag: contently.ui.current_user.name
      email: contently.ui.current_user.email
      role: contently.ui.current_user_role
      brand_profile_id: contently.ui.publication.id
      brand_profile_name: contently.ui.publication.name
      brand_profile_internal: contently.ui.publication.internal
      account_id: contently.ui.account.id
      account_name: contently.ui.account.name
      page: @options.page
      feature: "media-library"

    mixpanelEventOptions = $.extend(baseOptions, eventOptions)
    mixpanel.track(eventName, mixpanelEventOptions)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/media_library_assets_layout_view.js.coffee